import { StyledMobileCategories } from './styled';
import { SideMenuItemViewModel } from '~/features/navigation';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link as LinkType } from '~/lib/data-contract';
import { MobileCategoryLink } from './MobileCategoryLink';
import {
    StyledCategoriesFiltersContent,
    StyledResultsListShadow,
    StyledResultsListWrapper,
} from '$templates/blocks/components/M170Search/components/styled';

import { useFilterUIState } from '$features/productsList/hooks';
import { useInView } from 'framer-motion';
import { MobileFilterButtons } from '../../M170Search/components/MobileFilterButtons';

interface SideMenuProps {
    menus?: SideMenuItemViewModel[];
    breadcrumbs?: LinkType[];
}

export const MobileCategories = ({ menus, breadcrumbs }: SideMenuProps) => {
    const [currentLevel, setCurrentLevel] = useState<SideMenuItemViewModel>();
    const { setIconicFilterButtonsIsOutOfView } = useFilterUIState();

    const filterJustIconsButtons = useRef<HTMLDivElement | null>(null);
    const filterJustIconsButtonsInView = useInView(filterJustIconsButtons);

    useEffect(() => {
        setIconicFilterButtonsIsOutOfView(!filterJustIconsButtonsInView);
    }, [filterJustIconsButtonsInView, setIconicFilterButtonsIsOutOfView]);

    const isCurrent = useCallback(
        (item: SideMenuItemViewModel) => {
            return breadcrumbs && breadcrumbs[breadcrumbs.length - 1].url === item.url;
        },
        [breadcrumbs]
    );

    const checkIfCurrent = useCallback(
        (item: SideMenuItemViewModel[]) => {
            for (const menu of item) {
                if (isCurrent(menu)) {
                    setCurrentLevel(menu);
                    return;
                } else if (menu.children && menu.children?.length) {
                    checkIfCurrent(menu.children);
                }
            }
        },
        [setCurrentLevel, isCurrent]
    );

    useEffect(() => {
        if (!menus) return;
        checkIfCurrent(menus);
        return () => {
            setCurrentLevel(undefined);
        };
    }, [menus, setCurrentLevel, checkIfCurrent]);

    const shouldRenderCategories = Boolean(currentLevel && currentLevel?.children?.length);

    return (
        <StyledCategoriesFiltersContent>
            {shouldRenderCategories && (
                <StyledResultsListWrapper>
                    <StyledMobileCategories>
                        {(currentLevel as SideMenuItemViewModel).children?.map(
                            (subMenu, subMenuIndex) => (
                                <MobileCategoryLink
                                    key={subMenuIndex}
                                    url={subMenu.url}
                                    name={subMenu.name}
                                />
                            )
                        )}
                        <StyledResultsListShadow />
                    </StyledMobileCategories>
                </StyledResultsListWrapper>
            )}
            <MobileFilterButtons ref={filterJustIconsButtons} />
        </StyledCategoriesFiltersContent>
    );
};
